export var ClientErrorCodes;
(function (ClientErrorCodes) {
    ClientErrorCodes["LayoutMountFailed"] = "layout-mount-failed";
    ClientErrorCodes["LayoutMountFailedByTimeout"] = "layout-mount-failed-by-timeout";
    ClientErrorCodes["ImageLoadFailed"] = "image-load-failed";
    ClientErrorCodes["WrongShowParams"] = "wrong-show-params";
})(ClientErrorCodes || (ClientErrorCodes = {}));
//# sourceMappingURL=error-codes.constants.js.map